// KSDM SPA entry: boot gate, then render (renderApp.tsx).
//
// ★ PROD INVARIANT — Django-served pages are behaviorally unchanged. Every
// Django page (templates/common/react.html) injects window.__KSDM_CONFIG__
// synchronously before this module runs, so the `if` below is false and NO
// bootstrap fetch ever fires: the app renders off the injection exactly as
// before. The fallback exists ONLY for the bare Vite dev server
// (docs/LOCAL_QA_SETUP.md Mode A), where nothing injected the config.

async function boot(): Promise<void> {
  if (!window.__KSDM_CONFIG__) {
    // Bare Vite: ask Django (via the dev proxy) for the same config the
    // react.html shell would have injected.
    try {
      const res = await fetch('/api/v1.0/auth/bootstrap', {
        credentials: 'same-origin',
      });
      if (res.ok) {
        window.__KSDM_CONFIG__ = (await res.json()) as KsdmConfig;
      } else {
        // 401 = no session: render WITHOUT a config (the login page needs
        // none) but seed the csrftoken cookie so the login POST passes CSRF.
        // After login the page reloads (Login.tsx → location.href = '/'),
        // this gate runs again, and bootstrap succeeds with the new session.
        await fetch('/api/v1.0/auth/csrf', { credentials: 'same-origin' });
      }
    } catch {
      // Django unreachable (proxy target down / KSDM_DEV_PROXY wrong): still
      // render — the login page shows, and API calls surface their own errors.
    }
  }
  // Import AFTER the config is settled: app/store → authSlice seeds state from
  // getKsdmConfig() at module-eval time.
  await import('./renderApp');
}

void boot();
